import { assertIsNumber } from '../../../../lib/test-and-assert/assert-base';
import { formatting } from '../../../../qaamgo/helper/formatting';

export default class File {
    /**
     * @param {Number} localId
     */
    constructor(localId) {
        this.localId = localId;
        this.status = 'UNDEFINED';
        this.type = 'UNDEFINED';
        this.size = null;
        this.size_readable = null;
        this.name = null;
        this.progressPercent = 0; // between 0 and 100
        this.progressText = '';
        /** @type {Number[]} */
        this.progressBitrates = [];
        this.progressAverageBitrate = 0;
        this.metadata = {};
        this.lastEventData = null;
        this.bytesLoaded = 0;
        this.bytesTotal=0;
    }

    /**
     * @param {Input} input
     */
    setDataFromInput(input) {
        this.status = input.getStatus();
        this.type = input.getType();
        this.name = input.getName();
        this.size = input.getSize();
        this.size_readable = formatting.fileSize(input.getSize());

        if (input._metadata) {
            this.metadata = input._metadata;
        }
    }

    /**
     * @param {Number} currentBitrate
     */
    updateAverageBitrate(currentBitrate) {
        assertIsNumber(currentBitrate);

        this.progressBitrates.push(currentBitrate);

        // only take the newest bitrates
        this.progressBitrates = this.progressBitrates.slice(-20);

        let total = 0;

        this.progressBitrates.forEach((bitrate) => {
            total += bitrate;
        });

        this.progressAverageBitrate = total / this.progressBitrates.length;
    }
}
// export default new File();
